import React, { useState, memo } from "react";
import { Flex, Box, Image } from "rebass/styled-components";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { FloatingContainer } from "../../../components/wrappers/floatingContainer";
import { Title3 } from "../../../components/text";
import { FollowRow } from "../../molecules/followRow";
import { ReactComponent as Empty } from "../../../assets/images/emptyState/follow-empty.svg";
import Close from "../../../assets/images/floatingannouncement/close.svg";
import { getAvatarImage } from "../../../MVVM/Utilities/User";

export function FollowersModal({
  allstarUser,
  followerData,
  setModalOpen,
  followUnfollow,
  count,
  view,
}) {
  const history = useHistory();

  const [followersTabActive, setFollowersTabActive] = useState(
    view === "followers",
  );
  const [followingTabActive, setFollowingTabActive] = useState(
    view === "following",
  );

  history.listen((location, action) => {
    setModalOpen(false);
  });

  return (
    <>
      <StyledContainer>
        <Wrapper flexDirection={"column"}>
          <TabWrapper
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            pl={5}
            pr={2}
            pt={4}
          >
            <Flex height={"100%"}>
              <Tab
                onClick={() => {
                  setFollowersTabActive(true);
                  setFollowingTabActive(false);
                }}
                active={followersTabActive}
                pt={2}
                px={2}
                mr={5}
                justifyContent={"center"}
                alignItems={"center"}
              >
                {count.followers} Followers
              </Tab>
              <Tab
                onClick={() => {
                  setFollowingTabActive(true);
                  setFollowersTabActive(false);
                }}
                active={followingTabActive}
                pt={2}
                px={2}
                justifyContent={"center"}
                alignItems={"center"}
              >
                {count.following} Following
              </Tab>
            </Flex>

            <CloseIcon
              src={Close}
              mr={3}
              mb={4}
              onClick={() => {
                setModalOpen(false);
              }}
            ></CloseIcon>
          </TabWrapper>
          {
            <>
              {followersTabActive ? (
                <>
                  {followerData.followers.length ? (
                    <>
                      <UserList>
                        {followerData.followers.map((follower) => {
                          return (
                            <UserWrapper px={5} py={4}>
                              <FollowRow
                                {...follower}
                                avatar={getAvatarImage(follower)}
                                ownerId={follower._id}
                                followerData={followerData}
                                followUnfollow={followUnfollow}
                                allstarUser={allstarUser}
                                user={follower}
                              />
                            </UserWrapper>
                          );
                        })}
                      </UserList>
                    </>
                  ) : (
                    <NoOneHere />
                  )}
                </>
              ) : (
                <>
                  {followerData.following.length ? (
                    <>
                      <UserList>
                        {followerData.following.map((following) => {
                          return (
                            <UserWrapper px={5} py={4}>
                              <FollowRow
                                {...following}
                                avatar={getAvatarImage(following)}
                                ownerId={following._id}
                                followerData={followerData}
                                followUnfollow={followUnfollow}
                                allstarUser={allstarUser}
                                isModal={view}
                                user={following}
                              />
                            </UserWrapper>
                          );
                        })}
                      </UserList>
                    </>
                  ) : (
                    <NoOneHere />
                  )}
                </>
              )}
            </>
          }
        </Wrapper>
      </StyledContainer>
    </>
  );
}

const CloseIcon = styled(Image)`
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.midnight};
  border-radius: 999px;
  &:hover {
    background-color: ${(props) => props.theme.colors.darkerNed};
    transition: 0.3s;
  }
  width: 34px;
  height: 34px;
`;

const TabWrapper = styled(Flex)`
  border-radius: 20px 20px 0 0;
  height: 63px;
  background-color: ${(props) => {
    return props.theme.colors.midnight;
  }};
`;
const Tab = styled(Flex)`
  color: ${(props) => {
    return props.active
      ? `${props.theme.colors.envy}`
      : `${props.theme.colors.iceAlpha40}`;
  }};
  border-bottom: ${(props) => {
    return props.active ? `2px solid ${props.theme.colors.envy}` : ``;
  }};
  height: 100%;
  align-items: baseline;
  &:hover {
    cursor: pointer;
  }
`;
const UserList = styled(Flex)`
  flex-direction: column;
  overflow-y: scroll;
  overscroll-behavior: contain;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
  min-height: 500px;
  max-height: 500px;
`;
const EmptyFlex = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 500px;
  max-height: 500px;
`;
const Wrapper = styled(Flex)``;

const StyledContainer = styled(FloatingContainer)`
  background-color: #141c22;
  padding: 0px;
`;

const UserWrapper = styled(Flex)``;

const NoOneHere = memo(() => {
  return (
    <EmptyFlex>
      <Box as={Empty} width="125px" mb={5}></Box>
      <Title3 color="ice">No one here</Title3>
    </EmptyFlex>
  );
});
